import {
  Autocomplete,
  Box,
  Paper,
  TableContainer,
  TextField,
} from '@mui/material'
import { DataGridPro, GridColDef } from '@mui/x-data-grid-pro'
import { useHoldingContext } from '../Contexts/CurrentHolding'
import { tsCodeSetValue } from '../Typescript/API_Response'
import { useUserContext } from '../Contexts/UserConfig'
import { autoOptionsFromCodeValues } from '../Functions/ListItemGenerator'
import PageSection from '../Constants&Theme/PageSection'

type holdingColDef = GridColDef & { field: keyof tsCodeSetValue }
export const holdingCols: holdingColDef[] = [
  {
    field: 'CodeDescription',
    headerName: 'Code Description',
    flex: 1,
  },
]

function ChangeLocation() {
  const { loginConfig, loadingConfig } = useUserContext()
  const { currentHolding, setHolding } = useHoldingContext()
  const data = loginConfig?.CodeSets?.['KV-Holdings'].values
  return (
    <Box
      sx={{
        maxWidth: 'sm',
        width: 1,
      }}
    >
      <PageSection title={'Change Location'}>
        <Autocomplete
          autoSelect
          value={{ value: currentHolding?.value, label: currentHolding?.name }}
          sx={{ width: 1, mr: 1 }}
          onChange={(event: any, newValue: any) =>
            setHolding({ value: newValue.value, name: newValue.label })
          }
          isOptionEqualToValue={(option, value) => {
            return option.value === value.value
          }}
          options={autoOptionsFromCodeValues(data)}
          renderInput={(params: any) => (
            <TextField
              {...params}
              fullWidth
              label="Holding"
              placeholder={'Search...'}
            />
          )}
          disableClearable
        />
        <TableContainer
          component={Paper}
          sx={{
            maxWidth: 'xl',
            width: 1,
            height: 'calc(100vh - 350px)',
            maxHeight: 'calc(100vh - 300px)',
            mt: 2,
          }}
        >
          <DataGridPro
            hideFooter
            loading={loadingConfig}
            rows={data ?? []}
            getRowId={(row) => row.CodeValue}
            rowSelectionModel={[currentHolding.value]}
            columns={holdingCols}
            onRowClick={({ row }) =>
              setHolding({ value: row.CodeValue, name: row.CodeDescription })
            }
          />
        </TableContainer>
      </PageSection>
    </Box>
  )
}

export default ChangeLocation
